const KEY_STORAGE = "tender-ai.apiKey";
const TICKET_STORAGE = "tender-ai.apiTicket";

export function getApiKey(): string | null {
  const current = sessionStorage.getItem(KEY_STORAGE);
  if (current) return current;
  const legacy = localStorage.getItem(KEY_STORAGE);
  if (!legacy) return null;
  sessionStorage.setItem(KEY_STORAGE, legacy);
  localStorage.removeItem(KEY_STORAGE);
  return legacy;
}

export function setApiKey(value: string): void {
  sessionStorage.setItem(KEY_STORAGE, value);
  localStorage.removeItem(KEY_STORAGE);
}

export function clearApiKey(): void {
  sessionStorage.removeItem(KEY_STORAGE);
  localStorage.removeItem(KEY_STORAGE);
}

export function hasApiKey(): boolean {
  return Boolean(getApiKey()?.trim());
}

export function getApiTicket(): string | null {
  return sessionStorage.getItem(TICKET_STORAGE);
}

export function setApiTicket(value: string): void {
  sessionStorage.setItem(TICKET_STORAGE, value);
}

export function clearApiTicket(): void {
  sessionStorage.removeItem(TICKET_STORAGE);
}

// 嵌入会话只存内存 — 刷新即失, 用户从主平台重新进入 (方案 §3.4)。
// 有意不落 localStorage/sessionStorage: 它能提交分析, 暴露面必须最小。
let embedSession: string | null = null;

export function setEmbedSession(value: string): void {
  embedSession = value;
}

export function hasEmbedSession(): boolean {
  return Boolean(embedSession?.trim());
}

export function hasApiCredential(): boolean {
  return Boolean(getApiTicket()?.trim() || embedSession?.trim() || getApiKey()?.trim());
}

export function getApiAuthHeaders(): Record<string, string> {
  const ticket = getApiTicket()?.trim();
  if (ticket) return { "X-API-Ticket": ticket };
  const session = embedSession?.trim();
  if (session) return { "X-Embed-Session": session };
  const key = getApiKey()?.trim();
  if (key) return { "X-API-Key": key };
  return {};
}
